import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { openNotification } from '../../store/commonSlice';
import { notification } from '../../utils/constants';
import { getLocalStorage, getToken } from '../../utils/localStorage';

const PrivateRoute = ({ children }: { children: JSX.Element }) => {
	const location = useLocation();
	const dispatch = useDispatch();
	const tosStatus = getLocalStorage('termsOfServiceStatus');

	const isPasswordStrong = getLocalStorage('isPasswordStrong');
	const requiresEmailVerification = getLocalStorage('requiresEmailVerification');
	const goBackRestrictedRoutes: string[] = [
		'/password-update',
		'/terms-of-service',
		'/confirm-email'
	];

	useEffect(() => {
		const nonLoginCTR: any = document.querySelector('.nonlogin-ctr');
		const noginCTR: any = document.querySelector('.login-ctr');

		if (nonLoginCTR && noginCTR) {
			nonLoginCTR.style.display = 'none';
			noginCTR.style.display = 'block';
		}

		// Prevent browser back.
		if (goBackRestrictedRoutes.includes(location.pathname)) {
			window.history.pushState(null, '', window.location.href);

			window.onpopstate = function () {
				if (goBackRestrictedRoutes.includes(location.pathname)) {
					window.history.pushState(null, '', window.location.href);
					dispatch(
						openNotification({
							type: 'ERROR',
							heading: 'Error',
							body: notification.message.browserBackError
						})
					);
				}
			};
		} else {
			setTimeout(() => {
				const mainContainer = document.getElementById('main-container');

				if (mainContainer) {
					mainContainer.classList.remove('accout-login');
				}
			}, 0);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [location]);

	if (getToken()) {
		const nextPage = location.pathname;
		if (requiresEmailVerification === true) {
			if (nextPage !== '/confirm-email') {
				return <Navigate to="/confirm-email" />;
			}
		} else if (isPasswordStrong === false) {
			const userIcon: any = document.querySelector('.nav_bar__account a');

			if (userIcon) {
				userIcon.href = '#';
				dispatch(
					openNotification({
						type: 'ERROR',
						heading: 'Error',
						body: notification.message.updatePasswordMsg
					})
				);
			}
			if (nextPage !== '/password-update') {
				return <Navigate to="/password-update" />;
			}
		} else if (tosStatus !== 'ACTIVE') {
			if (nextPage !== '/terms-of-service') {
				return <Navigate to="/terms-of-service" />;
			}
		} else if (nextPage === '/password-update') {
			if (isPasswordStrong !== false) {
				return <Navigate to="/" />;
			}
		} else if (nextPage === '/terms-of-service') {
			if (tosStatus === 'ACTIVE') {
				return <Navigate to="/" />;
			}
		}

		return children;
	}

	return <Navigate to="/login" state={{ from: location }} replace />;
};

export default PrivateRoute;
